import React from 'react';
import { VIEW_TYPES, VIEW_TYPE_LABELS } from '../../../utils/campaignViews/index';
import ViewTypeIcon from './ViewTypeIcon';

/**
 * AddViewMenu - Dropdown menu for adding new custom views
 */
const AddViewMenu = ({ isOpen, onAddView }) => {
  if (!isOpen) return null;

  return (
    <div className="view-bar__add-menu">
      <div className="view-bar__add-menu-header">Add View</div>
      {Object.values(VIEW_TYPES).map(type => (
        <button
          key={type}
          className="view-bar__add-menu-item"
          onClick={() => onAddView(type)}
        >
          <ViewTypeIcon type={type} />
          <span>{VIEW_TYPE_LABELS[type]}</span>
        </button>
      ))}
    </div>
  );
};

export default AddViewMenu;
